// extracted by mini-css-extract-plugin
export var footerCheckboxContainer = "inscriptionNewsletter-module--footer-checkbox-container--a4bf6";
export var footerNewsletter = "inscriptionNewsletter-module--footer-newsletter--ce567";
export var footerNewsletterInput = "inscriptionNewsletter-module--footer-newsletter-input--590a0";
export var sectionAlert = "inscriptionNewsletter-module--section-alert--ed036";
export var sectionAlertButton = "inscriptionNewsletter-module--section-alert-button--b6eb5";
export var sectionAlertContent = "inscriptionNewsletter-module--section-alert-content--13048";
export var sectionAlertHeader = "inscriptionNewsletter-module--section-alert-header--bc2fb";
export var sectionAlertModal = "inscriptionNewsletter-module--section-alert-modal--ff10e";
export var sectionAlertTitle = "inscriptionNewsletter-module--section-alert-title--b39c4";